<script setup lang="ts">

</script>

<template>
  <p>{{ $route.name }}</p>
  <div class="bg-blue-400 p-4">
    Brand
  </div>
</template>
